import Icon from "@ch/components/Icons/Icon";
import type { FC } from "react";

export interface KemChatPrivacyToolbarProps {
  /** When set, shows the tour-targeted “Talk to Kem” control. */
  onTalkToKem?: () => void;
  canSpeakToKem?: boolean;
}

const KemChatPrivacyToolbar: FC<KemChatPrivacyToolbarProps> = ({
  onTalkToKem,
  canSpeakToKem = true,
}) => (
  <div className="flex min-w-0 items-center justify-end gap-2 py-1.5 sm:gap-3">
    {onTalkToKem !== undefined && (
      <button
        aria-label="Talk to Kem"
        className={`kem-tour-talk-to-kem flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 transition-transform hover:scale-105 active:scale-95 sm:gap-2 sm:px-4 ${canSpeakToKem ? "bg-green text-white" : "bg-gray-400 text-gray-600"}`}
        onClick={() => onTalkToKem()}
        title="Talk to Kem"
        type="button"
      >
        <Icon
          color={canSpeakToKem ? "#FFFFFF" : "#6B7280"}
          name="microphone"
          size={16}
        />
        <span className="text-xs font-semibold sm:text-sm">Talk to Kem</span>
      </button>
    )}

    <a
      aria-label="Privacy Policy"
      className="kem-tour-privacy-link"
      href="https://mymdoc.com/privacy-policy"
      rel="noopener noreferrer"
      target="_blank"
      title="Privacy Policy"
    >
      <Icon color="#00A859" name="alert-circle" size={20} />
    </a>
  </div>
);

export default KemChatPrivacyToolbar;
